import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { InternalGrid } from '@paygreen/paygreen-ui';
import { FormControlWrapper, ControlledDaInput } from '../../../../components';
import regexForm from '../../../../utils/regexForm';

const AdministratorManagementForm = ({
    t,
    errors,
    handleChange,
    onSubmit,
    children,
    defaultValues,
    control,
}) => {
    const transversalInputProps = {
        errors: errors,
        i18labelBase: 'admin.user.administratorInfos',
        hasChildrenStretched: true,
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <InternalGrid
                displayType="grid"
                gridGap="md"
                alignItems="stretch"
                justifyItems="stretch"
                gridTemplateColumns="1fr"
                childrenMarginBottom="none"
                childrenMarginTop="none"
            >
                <FormControlWrapper
                    inputName="administrator"
                    {...transversalInputProps}
                >
                    <ControlledDaInput
                        isDisabled
                        inputName="administrator"
                        inputType="text"
                        control={control}
                        defaultValue={defaultValues['administrator']}
                        hasStaticWidth={true}
                        onChange={handleChange}
                    />
                </FormControlWrapper>

                <FormControlWrapper
                    inputName="phone"
                    isRequired={true}
                    {...transversalInputProps}
                >
                    <ControlledDaInput
                        inputName="phone"
                        inputPattern={regexForm.phone}
                        inputType="tel"
                        control={control}
                        defaultValue={defaultValues.phone}
                        mask="+999 (0)9 99 99 99 99"
                        formatChars={{
                            9: '[0-9]',
                        }}
                        errorMessage={t(`form.error.phone`)}
                        hasStaticWidth={true}
                        onChange={handleChange}
                    />
                </FormControlWrapper>

                <FormControlWrapper
                    inputName="email"
                    isRequired={true}
                    {...transversalInputProps}
                >
                    <ControlledDaInput
                        inputName="email"
                        id="email"
                        inputType="email"
                        inputPattern={regexForm.email}
                        control={control}
                        defaultValue={defaultValues.email}
                        errorMessage={t(`form.error.email`)}
                        hasStaticWidth={true}
                        onChange={handleChange}
                    />
                </FormControlWrapper>
            </InternalGrid>

            {children}
        </form>
    );
};

AdministratorManagementForm.propTypes = {
    handleChange: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    /**
     * errors passed by react-hook-form for each field (necessary if you want errors management)
     */
    errors: PropTypes.object,
    defaultValues: PropTypes.object,
    control: PropTypes.object,
};

AdministratorManagementForm.defaultProps = {
    errors: {},
};

export default withTranslation('common')(AdministratorManagementForm);
